/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-use-before-define */
/* eslint-disable no-case-declarations */
/* eslint-disable eqeqeq */
/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */
/* eslint-disable react/no-did-update-set-state */
import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { Form } from 'react-form';
import * as queryString from 'query-string';
import { Link, Redirect, withRouter } from 'react-router-dom';
import moment from 'moment-timezone';
import { sumBy, cloneDeep, remove, find, get, some } from 'lodash';
import { parsePhoneNumber } from 'react-phone-number-input';
import ModalVideo from 'react-modal-video';
import NavigationPrompt from 'react-router-navigation-prompt';
import tzlookup from 'tz-lookup';
import Modal from '../../components/Modal/ReactBootstrapModal';

import Step from '../../components/Events/EventEditWizard/Step';
import StepFields from '../../components/Events/EventEditWizard/StepFields';
import { IncompleteApplicationPopup, WelcomePopUp } from '../../components/PopUps';
import ClubSelectForm from '../../components/ClubSelectForm';
import Img from '../../components/Img';
import UpgradeToPerformanceHsPopUp from '../../components/Upgrade/UpgradeToPerformanceHs/UpgradeToPerformanceHsPopUp';
import UpgradeToProClubPopUp from '../../components/Upgrade/UpgradeToProClubPopUp';

import { saveEvent } from '../../actions/event-actions';
import * as clubActions from '../../actions/club-actions';
import * as splashActions from '../../actions/splash-actions';
import * as eventTemplateActions from '../../actions/event-template-actions';
import { setJustPublishedFlag } from '../../actions/event-profile-actions';

import { determineStepTitle } from '../../utils/stepTitles';
import { isActive as isClubActive, canRunEvents as clubCanRunEvents, isHighSchoolClub, isPaymentProviderActive, isClubOwner, currentMemberIsAdmin, ClubTierTypes, getNewClubPath } from '../../utils/clubs';
import { eventDivisionIsPlatformPaymentOrFree, getDefaultDivision, PopUpTypes, mapDivisionsForSave, getClubListForCreateEvent, mapTemplateDivisionsForEdit, getAllowedEventTypes, eventEnum, shouldCheckForEventDuration, getEventDuration, getMaxEventDuration, EventTypes, getUsapDefaultQuestionIndex } from '../../utils/events';
import { getApiAxiosInstance } from '../../utils/network';
import { sportTypeIds, eventQuestionTypeIds, usapDefaultQuestion, verifiedAcceptanceMinValue, DefaultTimeZone } from '../../utils/eventConstants';
import * as clubsApi from '../../api/clubsApi';
import { payments } from '../../../constants';
import { eventCreateSteps, LocationTypeIds, SportTypes } from '../../utils/constants';
import { useStatsig } from '../../components/hooks/useStatsig';
import { showErrorPopup } from '../../actions/notification-actions';
import PopupV3, { PopupTypes } from '../../components/Popup/PopupV3';
import RecurringSubmissionPopups, { initializeRecurringPublishSelection } from '../../components/Events/EventEditWizard/RecurringSubmissionPopups';
import { fetchClubLocationsWithFacilities } from '../../actions/club-location-actions';

import config from '../../../config';
import { routerLocationShape, routerHistoryShape, clubShape, timeZoneShape } from '../../propTypes';
import styles from './eventCreate.scss';

const remainingTiersDefault = [
    { displayOrder: 10, shortName: ' ', sponsors: [] },
    { displayOrder: 9, shortName: ' ', sponsors: [] },
    { displayOrder: 8, shortName: ' ', sponsors: [] },
    { displayOrder: 7, shortName: ' ', sponsors: [] },
    { displayOrder: 6, shortName: ' ', sponsors: [] },
    { displayOrder: 5, shortName: ' ', sponsors: [] },
    { displayOrder: 4, shortName: ' Bronze Sponsors', sponsors: [] },
    { displayOrder: 3, shortName: ' Silver Sponsors', sponsors: [] },
    { displayOrder: 2, shortName: ' Gold Sponsors', sponsors: [] },
    { displayOrder: 1, shortName: ' Platinum Sponsors', sponsors: [] },
];
const _ = { sumBy, cloneDeep, remove, find, get, some };

const EventCreateForm = (props) => {
    const { clubIdInUrl, isDemoEvent, location, templateId } = props;
    const [tiers, setTiers] = useState({ tiers: [] });
    const [remainingTiers, setRemainingTiers] = useState(remainingTiersDefault);
    const [step, setStep] = useState(1);
    const [eventDataModified, setEventDataModified] = useState(false);
    const [errorPopUp, setErrorPopUp] = useState(false);
    const [eventTemplate, setEventTemplate] = useState(null);
    const [loading, setLoading] = useState(true);
    const [templateLoading, setTemplateLoading] = useState();
    const [submitting, setSubmitting] = useState(false);
    const [verificationApplied, setVerificationApplied] = useState(false);
    const [showUpgradeToPerformanceHsPopup, setShowUpgradeToPerformanceHsPopup] = useState(false);
    const [clubToUpgrade, setClubToUpgrade] = useState(null);
    const [showProClubPopup, setShowProClubPopup] = useState(false);
    const [success, setSuccess] = useState();
    const [error, setError] = useState();
    const [values, setValues] = useState({});
    const [tips, setTips] = useState({});
    const [showPaymentSetup, setShowPaymentSetup] = useState();
    const [organizers, setOrganizers] = useState();
    const [overrideClosePageWarning, setOverrideClosePageWarning] = useState();
    const [showIncompletePopup, setShowIncompletePopup] = useState();
    const [publish, setPublish] = useState();
    const [isOpen, setIsOpen] = useState();
    const [defaultFormValues, setDefaultFormValues] = useState();
    const [showRecurringSaveDraftPopup, setShowRecurringSaveDraftPopup] = useState(false);
    const [showRecurringPublishPopup, setShowRecurringPublishPopup] = useState(false);
    const [recurringPublishSelection, setRecurringPublishSelection] = useState([]);

    const formApiRef = useRef();
    const { checkGate, featureGates } = useStatsig();

    const auth = useSelector(({ auth }) => auth);
    const club = useSelector(({ club }) => club);
    const clubLocation = useSelector(({ clubLocation }) => clubLocation);
    const events = useSelector(({ events }) => events);
    const coreUI = useSelector(({ coreUI }) => coreUI);
    const dispatch = useDispatch();

    const { clubDetails, clubId, clubDetailsFetched } = club;
    const { locationsWithFacilities, areLocationsWithFacilitiesLoaded } = clubLocation;

    useEffect(() => {
        if (clubId && !areLocationsWithFacilitiesLoaded) {
            dispatch(fetchClubLocationsWithFacilities(clubId));
        }
    }, [clubId, areLocationsWithFacilitiesLoaded]);

    const defaultFacilitiesInitializedRef = useRef(false);
    useEffect(() => {
        if (
            defaultFacilitiesInitializedRef.current ||
            !areLocationsWithFacilitiesLoaded ||
            !locationsWithFacilities?.length ||
            !defaultFormValues ||
            !formApiRef.current
        ) {
            return;
        }

        const primaryLocation = locationsWithFacilities.find(
            (location) => location.locationTypeId === LocationTypeIds.PRIMARY,
        );

        if (!primaryLocation?.facilities?.length) {
            return;
        }

        const facilities = primaryLocation.facilities.map((facility) => ({
            clubLocationFacilityId: facility.id,
        }));

        if (formApiRef.current) {
            formApiRef.current.setValue('eventFacilities', facilities);
        }

        setDefaultFormValues((prev) => ({
            ...prev,
            eventFacilities: facilities,
        }));

        defaultFacilitiesInitializedRef.current = true;
    }, [areLocationsWithFacilitiesLoaded, locationsWithFacilities, defaultFormValues]);

    const queryParams = queryString.parse(location.search);
    const isEventRegisterAsIndidualEnabled = checkGate(featureGates.EVENT_REGISTER_AS_INDIVIDUAL);
    const isClubRedirectEnabled = checkGate(featureGates.CLUB_LINKS_REDIRECT);
    let { paymentProvider } = payments;
    if (clubDetails?.paymentProviderSetupType?.value) {
        paymentProvider = clubDetails.paymentProviderSetupType.value;
    }
    const activePaymentsEnabled = clubDetails?.paymentsEnabled && isPaymentProviderActive(clubDetails, paymentProvider);

    const isOwner = isClubOwner(clubDetails);
    const sportTypeId = parseInt(queryParams.sportTypeId || sportTypeIds.TENNIS);
    const isPickleballEvent = sportTypeId === sportTypeIds.PICKLEBALL;

    const timeZone = coreUI.types.timeZones.find(tz => { return tz.id === 77; });
    const tourDateStart = moment().tz(timeZone.value, true).add(2, 'days').set({ hour: 8, minute: 0, second: 0 });
    const tourDateEnd = moment().tz(timeZone.value, true).add(2, 'days').set({ hour: 21, minute: 0, second: 0 });
    const regDateStart = moment().tz(timeZone.value, true).set({ hour: 8, minute: 0, second: 0 });
    const regDateEnd = moment().tz(timeZone.value, true).add(1, 'days').set({ hour: 21, minute: 0, second: 0 });

    let stripeUrl = null;
    if (values) {
        stripeUrl =
            `${config.stripeHost}/oauth/authorize?client_id=${config.stripeClientId}` +
            `&state=${encodeURI(JSON.stringify({ eventId: values.id }))}` +
            '&response_type=code' +
            '&scope=read_write';
    }

    const { flow } = queryString.parse(location.search);
    let showTournamentClubEventPopUp = false;
    if (flow == 'tournament_club_create') {
        showTournamentClubEventPopUp = true;
    }

    const clubsList = getClubListForCreateEvent(club);
    const conditionIfPaymentSetup = showPaymentSetup && step === eventCreateSteps.STEPS_6;
    const conditionIfNotPaymentSetup = !showPaymentSetup && step === eventCreateSteps.STEPS_5;

    const allowToPublish = conditionIfPaymentSetup || conditionIfNotPaymentSetup;

    const moveToNext = eventCreateSteps.STEPS_6;
    const maxSteps = showPaymentSetup
        ? eventCreateSteps.STEPS_6
        : eventCreateSteps.STEPS_5;

    // Default Values

    const defaultLocation = {
        location: clubDetails?.location?.googleFormattedName || '',
        eventLocationType: '1',
    };
    // User location
    const userLocation = moment.tz.guess();
    const userLocationOffSet = moment.tz(userLocation).format('Z');
    // Event location
    const lat = clubDetails?.location?.latLng[0];
    const lng = clubDetails?.location?.latLng[1];
    const eventLocationZoneName = lat && lng ? tzlookup(lat, lng) : null;
    const eventLoctaionOffset = eventLocationZoneName ? moment.tz(eventLocationZoneName).format('Z') : null;
    const momentTz = isHighSchoolClub(clubDetails.tierType) ? userLocationOffSet : eventLoctaionOffset;
    let matchedTz;
    if (momentTz) {
        if (!isHighSchoolClub(clubDetails.tierType)) {
            matchedTz = coreUI.types.timeZones.find(tz => { return tz.offset === momentTz && tz.value === eventLocationZoneName; });
        } else {
            matchedTz = coreUI.types.timeZones.find(tz => { return tz.offset === momentTz; });
        }
    }
    const defaultTz = matchedTz ? matchedTz.id : DefaultTimeZone;

    const defaultValues = props.defaultValues || {
        club: parseInt(clubId),
        // type: 3,
        name: 'Untitled Event',
        eventPermissionType: 1,
        utrType: 1,
        hasAddEventSponsors: true,
        isPTTEvent: false,
        eventSchedule: {
            eventStartUtc: tourDateStart.toISOString(),
            eventEndUtc: tourDateEnd.toISOString(),
            registrationStartUtc: regDateStart.toISOString(),
            registrationEndUtc: regDateEnd.toISOString(),
            drawPublishedUtc: null,
            timeZone: defaultTz, // America/New York
        },
        eventDivisions: [],
        eventQuestions: [],
        passwordEnabled: false,
        eventPassword: '',
        eventDirectors: [{
            firstName: auth.user.firstName,
            imgUrl: '/img/default-profile-icon-120-x-120.svg',
            lastName: auth.user.lastName,
            memberId: auth.user.id,
            title: 'Head Provider',
            eventDirectorRole: 2,
        }],
        healthAndSafetyProtocols: [],
        eventLocations: [defaultLocation],
        cloneLastEvent: true,
        $clubJoin: clubDetails?.tierType?.id !== ClubTierTypes.TOURNAMENT && clubDetails?.tierType?.id !== ClubTierTypes.PREMIUM_LITE,
        $verified: clubDetails?.tierType?.verificationAllowed ? null : '1',
        sportTypeId: sportTypeId || sportTypeIds.TENNIS,
        hasEventAllottedMatchTimes: false,
        matchTimes: [],
        playerCountVisibility: true,
        tmsEventSponsors: {},
        eventFacilities: [],
    };

    if (auth.user.email) {
        defaultValues.email = auth.user.email;
    }

    if (auth.user.phone) {
        defaultValues.phone = auth.user.phone;
    }

    useEffect(() => {
        window.addEventListener('beforeunload', onUnload);
        const { clubId, step } = queryString.parse(location.search);
        if (step) {
            setStep(parseInt(step));
        }
        if (clubId) {
            getClubAdmins();
        }
        if (templateId) {
            setTemplateLoading(true);
            getTemplate(templateId);
        } else {
            setDefaultFormValues(defaultValues);
        }
        setLoading(false);

        if (props.club?.clubDetails?.sanctioned || props.club?.clubDetails?.verificationApplicationStatus != '') {
            setVerificationApplied(true);
        }

        return () => {
            window.removeEventListener('beforeunload', onUnload);
        };
    }, []);

    useEffect(() => {
        const { clubId } = queryString.parse(location.search);
        if (clubId) {
            if (!clubIdInUrl) {
                getClubAdmins();
            }
        }
    }, [auth.user]);

    useEffect(() => {
        const defaultValuesToSet = { ...defaultValues };
        if (eventTemplate && !loading) {
            const { id, template } = eventTemplate;
            const pttTourTag = 'UTR Pro Tennis Tour';

            defaultValuesToSet.templateId = id;
            defaultValuesToSet.isPTTEvent = template?.tours?.includes(pttTourTag);

            // step 1
            defaultValuesToSet.eventType = template?.eventType ?? defaultValues.eventType;
            if (clubDetails?.tierType) {
                const eventTypeOptions = getAllowedEventTypes({
                    club: club.clubDetails,
                    sportTypeId,
                });
                if (!_.some(eventTypeOptions, { id: defaultValuesToSet.eventType })) {
                    defaultValuesToSet.eventType = null;
                }
            }
            defaultValuesToSet.$verified = template?.verified?.toString() ?? defaultValues.$verified;
            defaultValuesToSet.hasPrizeMoney = template?.hasPrizeMoney ?? defaultValues.hasPrizeMoney;
            defaultValuesToSet.prizeMoney = template?.prizeMoney ?? defaultValues.prizeMoney;
            if (clubDetails?.tierType?.id !== ClubTierTypes.HIGH_SCHOOL) {
                defaultValuesToSet.entryFee = template?.entryFee ?? defaultValues.entryFee;
                if (defaultValuesToSet.entryFee) {
                    defaultValuesToSet.hasEntryFee = true;
                }
            }
            defaultValuesToSet.preventDivisionDateRegistrationConflicts = template?.preventDivisionDateRegistrationConflicts ?? defaultValues.preventDivisionDateRegistrationConflicts;
            if (defaultValuesToSet.preventDivisionDateRegistrationConflicts) {
                defaultValuesToSet.preventDivisionDateRegistrationConflicts = false;
            }

            defaultValuesToSet.preventProAmDivisionRegistrationConflicts = template?.preventProAmDivisionRegistrationConflicts ?? defaultValues.preventProAmDivisionRegistrationConflicts;
            if (defaultValuesToSet.preventProAmDivisionRegistrationConflicts) {
                defaultValuesToSet.preventProAmDivisionRegistrationConflicts = false;
            }

            if (isPickleballEvent) {
                defaultValuesToSet.usapVerificationTypeId = template?.usapVerificationTypeId ?? defaultValues.usapVerificationTypeId;
                if (defaultValuesToSet.usapVerificationTypeId) {
                    defaultValuesToSet.hasUsapVerificationTypeId = true;
                }
            }
            const { acceptanceListRoundTypes } = coreUI.types.tms.division.tournament;

            if (!isEventRegisterAsIndidualEnabled && template?.eventDivisions.length > 0) {
                template.eventDivisions.forEach(div => {
                    if (div?.registerAsIndividual) {
                        div.registerAsIndividual = false;
                    }
                });
            }

            if (defaultFormValues) {
                if (eventTemplate?.percentFee === null) {
                    if (sportTypeId === SportTypes.Tennis) {
                        defaultFormValues.percentFee = clubDetails?.tmsPercentFee;
                    }
                    if (sportTypeId === SportTypes.Pickleball) {
                        defaultFormValues.percentFee = clubDetails?.clubSettings?.tmsPickleballPercentFee;
                    }
                } else {
                    defaultFormValues.percentFee = eventTemplate?.percentFee;
                }
            }

            defaultValuesToSet.eventDivisions = mapTemplateDivisionsForEdit(template?.eventDivisions ?? defaultValues.eventDivisions, acceptanceListRoundTypes, sportTypeId, defaultValuesToSet.$verified);

            if (defaultValuesToSet.eventDivisions.length === 0 && !!defaultValuesToSet.eventType) {
                const currencyId = club?.clubDetails?.currency?.id;
                defaultValuesToSet.eventDivisions = [getDefaultDivision(defaultValues, currencyId, true, sportTypeId, auth?.user)];
            }

            // step 3
            defaultValuesToSet.name = template?.name ?? defaultValues.name;
            defaultValuesToSet.details = template?.details ?? defaultValues.details;
            defaultValuesToSet.eventPermissionType = template?.eventPermissionType ?? defaultValues.eventPermissionType;
            defaultValuesToSet.allowPlayerPosting = template?.allowPlayerPosting ?? defaultValues.allowPlayerPosting;
            defaultValuesToSet.$clubJoin = template?.eventClubJoinRequestType === 2;
            defaultValuesToSet.playerVisibility = template?.playerVisibility ?? defaultValues.playerVisibility;
            defaultValuesToSet.needPartnerVisibility = template?.needPartnerVisibility ?? defaultValues.needPartnerVisibility;
            defaultValuesToSet.playerCountVisibility = template?.playerCountVisibility ?? defaultValues.playerCountVisibility;
            defaultValuesToSet.utrType = template?.utrType ?? defaultValues.utrType;
            defaultValuesToSet.eventQuestions = template?.eventQuestions ?? defaultValues.eventQuestions;
            const usapDefaultQuestionIndex = getUsapDefaultQuestionIndex(defaultValuesToSet?.eventQuestions);
            if (!defaultValuesToSet.hasUsapVerificationTypeId && usapDefaultQuestionIndex !== -1) {
                const filterValue = defaultValuesToSet.eventQuestions.filter(val => val.type !== eventQuestionTypeIds.THIRDPARTY_ID);
                defaultValuesToSet.eventQuestions = filterValue;
            }
            if (defaultValuesToSet.hasUsapVerificationTypeId && usapDefaultQuestionIndex === -1) {
                const defaultQuestion = {
                    text: usapDefaultQuestion,
                    required: true,
                    type: eventQuestionTypeIds.THIRDPARTY_ID,
                };
                defaultValuesToSet.eventQuestions.unshift(defaultQuestion);
            }
        }
        setDefaultFormValues(defaultValuesToSet);
    }, [eventTemplate]);

    const setupStripeAccount = async () => {
        await clubsApi.setupStripeAccount(getApiAxiosInstance(), clubId, {
            code: queryParams.code,
            redirectUri: `${config.appHost}/events/${values.id}/edit?step=5`, // TODO:
        });
    };

    useEffect(() => {
        if (clubDetails && !activePaymentsEnabled) {
            const queryParams = queryString.parse(location.search);
            if (queryParams.code && !loading && !success && !error && !errorPopUp) {
                setLoading(true);
                setStep(5);
                try {
                    setupStripeAccount();
                    dispatch(clubActions.setClubId(clubId));
                    setLoading(false);
                    setSuccess(true);
                } catch (error) {
                    console.log(error.response);
                    setLoading(false);
                    setError(error.response ? error.response.data : 'error');
                }
            }
        }
    }, [club]);

    const onDivisionFeeChange = (value) => {
        setTips({
            ...tips,
            entryFee: !value,
        });
    };

    const onHSEventTypeChange = (value) => {
        const val = parseInt(value);
        const { reset, setValue } = formApiRef.current;
        reset('eventType');
        setValue('hsEventType', val);
    };

    const onEventTypeChange = (e) => {
        const val = parseInt(e.target.value);
        const { values, reset, setValue, addValue } = formApiRef.current;
        reset();
        setValue('healthAndSafetyProtocols', []);
        if (isHighSchoolClub(clubDetails.tierType)) {
            if (values.hsEventType === EventTypes.TOURNAMENT || val === EventTypes.DUAL_MATCH) { // if official highschool match verified is true
                setValue('$verified', '2');
            } else if (values.hsEventType === EventTypes.LEAGUE_OR_TEAM) {
                setValue('$verified', '1');
            } else {
                setValue('$verified', values.$verified);
            }
        } else {
            setValue('$verified', values.$verified);
        }
        const tempValues = _.cloneDeep(values);
        tempValues.eventType = val;
        if (!Object.hasOwn(tempValues, 'playerVisibility')) {
            setValue('playerVisibility', true);
        }

        const currencyId = clubDetails?.currency?.id;
        if (!(tempValues.eventDivisions && tempValues.eventDivisions.length > 0)) {
            addValue('eventDivisions', getDefaultDivision(tempValues, currencyId, true, sportTypeId));
        } else {
            const defaultDivision = getDefaultDivision(tempValues, currencyId, true, sportTypeId);
            tempValues.eventDivisions[0].name = defaultDivision.name;
            setValue('eventDivisions', tempValues.eventDivisions);
        }

        if (val === 11) { // flex league event
            setValue('allowPlayerPosting', true);
        }
        setTips({
            ...tips,
            eventType: !val,
            verifiedEvent: true,
        });
    };

    useEffect(() => {
        if (formApiRef?.current) {
            const { setValue } = formApiRef.current;
            setValue('tiers', tiers.tiers);
        }
    }, [tiers]);
    const onUnload = (e) => {
        // browser api handles the warning
        console.log('Leave page? Changes you made may not be saved.');
        if (eventDataModified) {
            e.returnValue = 'Leave page? Changes you made may not be saved.';
        }
    };

    const onVerifiedChange = (value) => {
        checkAndUpdateEventDivisions();
        setTips({
            ...tips,
            verifiedEvent: !value,
        });
    };

    const getTemplate = async (templateId) => {
        dispatch(splashActions.showSplash({
            splash: 'load',
            title: 'Loading',
        }));
        const res = await dispatch(eventTemplateActions.fetchEventTemplate(templateId));
        dispatch(splashActions.hideSplash());
        if (!res?.data?.error) {
            setEventTemplate(res.data);
        }
        setTemplateLoading(false);
    };

    const getStepTitles = (currentStep, clubDetails) => {
        const isOwner = isClubOwner(clubDetails);
        const activePaymentsEnabled = isPaymentProviderActive(clubDetails, paymentProvider);
        return determineStepTitle(currentStep, activePaymentsEnabled, clubDetails, isOwner);
    };

    const getClubAdmins = async () => {
        const organizers = [{
            firstName: auth.user.firstName,
            imgUrl: '/img/default-profile-icon-120-x-120.svg',
            lastName: auth.user.lastName,
            memberId: auth.user.id,
            title: 'Head Provider',
            eventDirectorRole: 2,
        }];
        setOrganizers(organizers);
    };

    const updateEventDataModified = () => {
        setEventDataModified(true);
        if (formApiRef?.current?.errors && formApiRef?.current?.submitting) {
            setSubmitting(false);
            setJustPublishedFlag(false);
        }
    };

    const onShowUpgradeToPerformanceHsPopup = () => {
        setShowUpgradeToPerformanceHsPopup(true);
        setClubToUpgrade([{
            value: clubId,
            label: clubDetails.name,
        }]);
    };

    const handlePerformanceHsPopupCloseClick = () => {
        setShowUpgradeToPerformanceHsPopup(true);
        setClubToUpgrade(null);
    };

    const handlePerformanceHsPopupUpgradeClick = () => {
        setShowUpgradeToPerformanceHsPopup(true);
        setClubToUpgrade(null);
        setShowProClubPopup(null);
    };

    const handleProClubSuccess = () => {
        setOverrideClosePageWarning(true);
        if (clubId) {
            if (isClubRedirectEnabled) {
                dispatch(splashActions.showSplash());
                const clubTierTypeId = clubDetails.tierTypeId || clubDetails.tierType?.id;
                const newClubPath = getNewClubPath(clubTierTypeId);
                window.location.href = `${config.nextAppHost}/${newClubPath}/${clubId}`;
                return;
            }
            props.history.push(`/clubs/${clubId}`);
            dispatch(clubActions.getClubDetailsOnly()); // refetch club details as tiertype changed
        } else {
            props.history.push(`/home`);
        }
    };

    const applyForVerified = async (autoApprove) => {
        await dispatch(clubActions.applyForVerified(clubId, autoApprove));
        setVerificationApplied(true);
    };

    const checkAndUpdateEventDivisions = () => {
        if (formApiRef.current) {
            const values = _.cloneDeep(formApiRef.current.values);
            // update values for divisions after updating to verified events
            const eventDivisions = values.eventDivisions.map((division) => {
                // default to officilas for a verified event
                division.officialsType = '2';
                // change max players to min 4 if chosen less than 4 before making it verified
                division.maxPlayers = parseInt(division.maxPlayers) < verifiedAcceptanceMinValue ? verifiedAcceptanceMinValue : division.maxPlayers;
                return division;
            });
            formApiRef.current.setValue('eventDivisions', eventDivisions);
        }
    };

    const closeCreatePage = (override) => {
        setOverrideClosePageWarning(override || false);
        if (clubId) {
            if (isClubRedirectEnabled) {
                dispatch(splashActions.showSplash());
                const clubTierTypeId = clubDetails.tierTypeId || clubDetails.tierType?.id;
                const newClubPath = getNewClubPath(clubTierTypeId);
                window.location.href = `${config.nextAppHost}/${newClubPath}/${clubId}`;
                return;
            }
            props.history.push(`/clubs/${clubId}`);
        } else {
            props.history.push(`/home`);
        }
    };

    const closePopups = () => {
        setShowIncompletePopup(false);
    };

    const closeTournamentClubEventPopUp = () => {
        const queryParams = queryString.parse(location.search);
        delete queryParams.flow;
        props.history.push({
            pathname: location.pathname,
            search: queryString.stringify(queryParams),
        });
    };

    const handleClubSelectCancel = () => {
        props.history.goBack();
    };

    const handleClubSelectSubmit = (values) => {
        if (values?.clubId) {
            props.history.push(`/events/create?clubId=${values.clubId}`);
        }
    };

    const handleStepBack = () => {
        setStep(step - 1);
    };

    const applyPublishSelectionToRecurrenceSettings = (recurrenceSettings, publishSelection = recurringPublishSelection) => {
        if (!recurrenceSettings?.cadenceId || !publishSelection?.length) {
            return recurrenceSettings;
        }
        const publishSelectionByKey = new Map();
        publishSelection.forEach((recurrentEvent, index) => {
            const rowKey = recurrentEvent.id || recurrentEvent.order || index + 1;
            publishSelectionByKey.set(rowKey, recurrentEvent);
        });
        return {
            ...recurrenceSettings,
            recurrentEvents: (recurrenceSettings.recurrentEvents || []).map((recurrentEvent, index) => {
                const rowKey = recurrentEvent.id || recurrentEvent.order || index + 1;
                const selectedEvent = publishSelectionByKey.get(rowKey);
                return {
                    ...recurrentEvent,
                    publishOnCreate: typeof selectedEvent?.publishOnCreate === 'boolean'
                        ? selectedEvent.publishOnCreate
                        : !!recurrentEvent.publishOnCreate,
                };
            }),
        };
    };

    const handleSubmit = async (newValues, goToStep) => {
        console.log(`New Event Step ${step} Submit`);
        console.table(newValues);
        let newValuesPatch = {};
        if (newValues) {
            newValuesPatch = newValues.values ? newValues.values : newValues;
        }
        const updated = {
            ...values,
            ...newValuesPatch,
        };
        if (publish) {
            updated.published = true;
            updated.$justPublished = true;
            updated.recurrenceSettings = applyPublishSelectionToRecurrenceSettings(updated.recurrenceSettings);
        }
        if (updated.eventSchedule) {
            const timeZone = coreUI.types.timeZones.find(tz => { return tz.id === parseInt(updated.eventSchedule.timeZone); });
            const timeZonePrev = values?.eventSchedule && coreUI.types.timeZones.find(tz => {
                return tz.id === parseInt(values.eventSchedule.timezone || values.eventSchedule.timeZone);
            });
            const shiftTimeZone = values?.eventSchedule && parseInt(values.eventSchedule.timezone || values.eventSchedule.timeZone) !== parseInt(updated.eventSchedule.timezone || updated.eventSchedule.timeZone);
            updated.eventSchedule.eventStartUtc = shiftTimeZone ? moment(updated.eventSchedule.eventStartUtc).tz(timeZonePrev.value).tz(timeZone.value, true) : updated.eventSchedule.eventStartUtc;
            updated.eventSchedule.eventEndUtc = shiftTimeZone ? moment(updated.eventSchedule.eventEndUtc).tz(timeZonePrev.value).tz(timeZone.value, true) : updated.eventSchedule.eventEndUtc;
            updated.eventSchedule.registrationStartUtc = shiftTimeZone ? moment(updated.eventSchedule.registrationStartUtc).tz(timeZonePrev.value).tz(timeZone.value, true) : updated.eventSchedule.registrationStartUtc;
            updated.eventSchedule.registrationEndUtc = shiftTimeZone ? moment(updated.eventSchedule.registrationEndUtc).tz(timeZonePrev.value).tz(timeZone.value, true) : updated.eventSchedule.registrationEndUtc;
            if (updated.eventSchedule.drawPublishedUtc) {
                updated.eventSchedule.drawPublishedUtc = shiftTimeZone ? moment(updated.eventSchedule.drawPublishedUtc).tz(timeZonePrev.value).tz(timeZone.value, true) : updated.eventSchedule.drawPublishedUtc;
            }
        }
        setSubmitting(!goToStep);
        setValues(updated);

        if (goToStep) {
            if (updated.eventDivisions.find(div => div.entryFee && div.entryFee > 0 && (eventDivisionIsPlatformPaymentOrFree(div) && !club.clubDetails.allowOffPlatformPayments)) && !activePaymentsEnabled) {
                setShowPaymentSetup(true);
            } else {
                setShowPaymentSetup(false);
            }
            const nextStep = goToStep === 'prev' ? step - 1 : step + 1;
            if (nextStep === moveToNext) {
                // save event before continuing
                const isSaved = await handleSaveEvent(updated, true);
                if (!isSaved) {
                    return;
                }
            }
            toStep(goToStep);
        } else {
            if (shouldCheckForEventDuration(updated, updated.eventSchedule)) {
                if (getEventDuration(updated.eventSchedule) >= getMaxEventDuration(clubDetails.clubSettings)) {
                    dispatch(showErrorPopup({
                        message: `The event end date can not be more than ${getMaxEventDuration(clubDetails.clubSettings)} days apart from event start date`,
                        error: null,
                    }));

                    setSubmitting(false);
                    return;
                }
            }
            const isSaved = await handleSaveEvent(updated);
            if (!isSaved) {
                return;
            }
        }

        if (window) {
            window.scrollTo(0, 0);
        }
    };

    const openModal = (video) => {
        setIsOpen(video);
    };

    const submitPublishEvent = (publishSelection = null) => {
        const clubIsSanctioned = clubDetails ? clubDetails.sanctioned : false;
        const paymentsEnabledForClub = clubDetails ? clubDetails.paymentsEnabled : false;
        const currentValues = _.cloneDeep(formApiRef.current?.values || values);
        if (publishSelection?.length && currentValues?.recurrenceSettings?.cadenceId) {
            currentValues.recurrenceSettings = applyPublishSelectionToRecurrenceSettings(currentValues.recurrenceSettings, publishSelection);
            if (formApiRef.current) {
                formApiRef.current.setValue('recurrenceSettings.recurrentEvents', currentValues.recurrenceSettings.recurrentEvents);
            }
        }
        const eventDivisionEntryFeeSum = currentValues?.eventDivisions ? _.sumBy(currentValues.eventDivisions, (division) => { return division.entryFee ? parseInt(division.entryFee) : 0; }) : 0;
        const clubAllowOffPlatformPayments = clubDetails ? clubDetails.allowOffPlatformPayments : false;
        if (currentValues?.$verified === '2' && !clubIsSanctioned) {
            setShowIncompletePopup(true);
        } else if (!paymentsEnabledForClub && eventDivisionEntryFeeSum > 0 && !clubAllowOffPlatformPayments) {
            dispatch(showErrorPopup({
                message: 'Unable to publish event. An active club payment account is required.',
                error: null,
            }));
        } else if (!submitting) {
            setSubmitting(true);
            formApiRef.current.submitForm();
        }
    };

    const publishEvent = () => {
        const currentValues = formApiRef.current?.values || values;
        const recurrenceSettings = currentValues?.recurrenceSettings;
        if (recurrenceSettings?.cadenceId) {
            setRecurringPublishSelection(initializeRecurringPublishSelection(recurrenceSettings?.recurrentEvents || []));
            setPublish(true);
            setShowRecurringPublishPopup(true);
            return;
        }
        setPublish(true);
        submitPublishEvent();
    };

    const saveDraftEvent = () => {
        const currentValues = formApiRef.current?.values || values;
        const recurrenceSettings = currentValues?.recurrenceSettings;
        if (recurrenceSettings?.cadenceId) {
            setPublish(false);
            setShowRecurringSaveDraftPopup(true);
            return;
        }
        if (!submitting) {
            setSubmitting(true);
            formApiRef.current.submitForm();
        }
    };

    const updateRecurringPublishSelection = (key, publishOnCreate) => {
        setRecurringPublishSelection((prevSelection) => prevSelection.map((recurrentEvent, index) => {
            const rowKey = recurrentEvent.id || recurrentEvent.order || index + 1;
            if (rowKey !== key) {
                return recurrentEvent;
            }
            return {
                ...recurrentEvent,
                publishOnCreate,
            };
        }));
    };

    const toggleSelectAllRecurringPublishSelection = (nextValue) => {
        setRecurringPublishSelection((prevSelection) => prevSelection.map((recurrentEvent) => ({
            ...recurrentEvent,
            publishOnCreate: nextValue,
        })));
    };

    const confirmRecurringSaveDraft = () => {
        setShowRecurringSaveDraftPopup(false);
        if (!submitting) {
            setSubmitting(true);
            formApiRef.current.submitForm();
        }
    };

    const confirmRecurringPublish = () => {
        setShowRecurringPublishPopup(false);
        submitPublishEvent(recurringPublishSelection);
    };

    const handleSaveEvent = async (updatedValues, toNextStep) => {
        const { tiers, ...updated } = updatedValues;
        if (tiers) {
            updated.tmsEventSponsors = {
                sponsorTiers: tiers.map((tier) => ({
                    shortName: tier.shortName,
                    displayOrder: tier.displayOrder,
                    sponsors: tier.sponsors.map(sponsor => ({
                        sponsorName: sponsor.sponsorName,
                        callToActionURL: sponsor.callToActionURL,
                        imageFile: sponsor.imageFile,
                        displayOrder: sponsor.displayOrder,
                    })),
                })),
            };
        }

        setSubmitting(true);
        const vals = updated;
        if (clubId) {
            vals.club = clubId;
        }
        if (isDemoEvent) {
            vals.isDemoEvent = isDemoEvent;
        }
        vals.club = clubId;
        if (vals.name) {
            vals.name = vals.name.trim();
        }
        if (vals.eventDirectors && organizers) {
            vals.eventDirectors = organizers.map(div => {
                div.eventDirectorRole = 1;
                return div;
            });
        }
        if (vals.phone) {
            const parsedPhone = parsePhoneNumber(vals.phone);
            vals.phoneCountryCode = parsedPhone ? parsedPhone.country : null;
        }
        if (vals.eventDivisions) {
            const { acceptanceListRankingTypes, acceptanceListRoundTypes } = coreUI.types.tms.division.tournament;
            const useAcceptanceList = true;
            vals.eventDivisions = mapDivisionsForSave(vals.eventDivisions, acceptanceListRankingTypes, acceptanceListRoundTypes, useAcceptanceList);
        }

        if (vals.eventQuestions) {
            vals.eventQuestions = vals.eventQuestions.filter(question => {
                return question?.text?.trim();
            });
        }

        // map toggles to type selects
        vals.utrType = vals.$verified;
        vals.eventClubJoinRequestType = vals.$clubJoin ? 2 : 1;

        if (vals.eventType == eventEnum.dualMatchEvent || vals.eventType === eventEnum.adultTeamTennisEvent) {
            vals.isConference = vals.$isConference === '2';
        }

        if (publish && vals?.recurrenceSettings?.cadenceId) {
            vals.recurrenceSettings = applyPublishSelectionToRecurrenceSettings(vals.recurrenceSettings);
        }
        vals.recurrenceSettings = vals?.recurrenceSettings?.cadenceId ? vals.recurrenceSettings : null;

        if (vals.eventDivisions.find(div => div.entryFee && div.entryFee > 0 && (eventDivisionIsPlatformPaymentOrFree(div) && !club.clubDetails.allowOffPlatformPayments)) && !activePaymentsEnabled) {
            setShowPaymentSetup(true);
        } else {
            setShowPaymentSetup(false);
        }

        dispatch(splashActions.showSplash({
            splash: 'save',
            title: 'Saving',
        }));

        const savedEvent = await dispatch(saveEvent(vals, (vals.eventType == eventEnum.dualMatchEvent || vals.eventType === eventEnum.adultTeamTennisEvent), (clubDetails?.lastEventIds?.[vals.eventType] && vals.cloneLastEvent) ? clubDetails.lastEventIds?.[vals.eventType] : false));
        dispatch(clubActions.getClubDetailsOnly());

        setSubmitting(false);

        if (savedEvent) {
            setEventDataModified(false);

            dispatch(splashActions.hideSplash());
            if (!toNextStep) {
                props.history.push({
                    pathname: `/events/${savedEvent.id}`,
                    state: { adminSplash: savedEvent.published ? 'Your event has been published!' : 'Your event has been created!' },
                });
            } else {
                dispatch(splashActions.hideSplash());

                // to update event in create mode
                const newValues = values;
                newValues.id = savedEvent.id;
                // eslint-disable-next-line array-callback-return
                savedEvent.eventDivisions.map((div, i) => {
                    if (!newValues.eventDivisions[i].id) {
                        newValues.eventDivisions[i].id = div.id;
                    }
                });
                vals.eventClubJoinRequestType = vals.$clubJoin ? 2 : 1;
                newValues.eventClubJoinRequestType = savedEvent.eventClubJoinRequestType;
                const { setValue } = formApiRef.current;
                setValue('eventDivisions', newValues.eventDivisions);
                setValue('$clubJoin', (savedEvent.eventClubJoinRequestType === 2));
                setValues(newValues);
            }
            return true;
        }
        dispatch(splashActions.hideSplash());
        return false;
    };

    const toStep = (direction) => {
        setStep(direction == 'prev' ? (step - 1) : (step + 1));
    };

    const isNotTeamTennisOrDualMatch = (formValues) => {
        const eventTypeOptions = getAllowedEventTypes({
            club: clubDetails,
            sportTypeId,
        });

        return eventTypeOptions.some(type => type.id !== EventTypes.DUAL_MATCH && type.id !== EventTypes.TEAM_MATCH) &&
            formValues?.eventType !== EventTypes.DUAL_MATCH &&
            formValues?.eventType !== EventTypes.TEAM_MATCH;
    };

    // RENDER ------------------

    return (
        <div>
            <ModalVideo channel="youtube" isOpen={isOpen === 'video1'} videoId={'GFpP7DMf8pY'} autoplay={true} onClose={() => setIsOpen(false)} />
            <ModalVideo channel="youtube" isOpen={isOpen === 'video2'} videoId={'1efJOfGhzaY'} autoplay={true} onClose={() => setIsOpen(false)} />
            <div className="navbar navbar-expand-md navbar-light mt0 sticky-top">
                <div className="container" style={{ position: 'relative' }}>
                    <div className="row w-100">
                        <div className="col d-flex aic">
                            <div className="close-area" onClick={closeCreatePage} data-testid="event-create.close-btn">
                                <Img className="close-icon" src="/img/icons/close-icon-lg.svg" />
                            </div>
                            <div className="d-inline d-md-none title-span text-medium text-uppercase text-dark text-center" data-testid="event-create.header.mobile-title">
                                Create Event
                            </div>
                        </div>
                        <div className="col d-none d-md-flex aic jcc">
                            <div className="title-span text-medium text-uppercase text-dark text-center" data-testid="event-create.page.title">
                                Create Event
                            </div>
                        </div>
                        <div className="col d-flex aic jce">
                            {isNotTeamTennisOrDualMatch() && (
                                <>
                                    <span className="clickable" onClick={saveDraftEvent} data-testid="event-edit.save-draft-btn">Save Draft</span>&nbsp;
                                    {allowToPublish &&
                                        <>&nbsp;<span className="clickable d-md-none" onClick={publishEvent} data-testid="event-create.publish-btn">Publish</span></>}
                                    {!allowToPublish &&
                                        <>&nbsp;<span className="d-md-none" data-testid="event-create.publish-btn-disabled">Publish</span></>}
                                    <button type="button" className="btn btn-primary btn-lg text-uppercase ml16 d-none d-md-inline-block" onClick={publishEvent} disabled={!allowToPublish} data-testid="event-create.publish-btn">Publish</button>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <div className={styles.page}>
                <div className="container">
                    <div className="row">
                        <div className="col-12 col-md-6 offset-md-3">
                            {clubIdInUrl && (
                                <>
                                    {step === 1 && (
                                        <div className={`${styles.section}`}>
                                            {(clubDetailsFetched && (!isClubActive(clubDetails) || !clubDetails || !clubCanRunEvents(clubDetails) || !currentMemberIsAdmin(clubDetails))) && (
                                                <Redirect to="/clubs" />
                                            )}
                                            <div className={`container bg-transparent pl0 pr0 pb8`}>
                                                {clubDetails && (
                                                    <div className={`text-highlight2 text-teal`}>
                                                        <Link to={`/clubs/${clubDetails.id}`}>{clubDetails.name}</Link>
                                                    </div>
                                                )}
                                                <h2 data-testid="event-create.step1.create-event-title">
                                                    Create a {isPickleballEvent ? 'Pickleball' : 'Tennis'} Event
                                                </h2>
                                                <div className="bb pb8">
                                                    {clubDetails && !clubDetails.eventCount ? 'Let`s start creating your first event' : 'Let`s start creating your next event'}
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    {clubDetails && !loading && !templateLoading && (
                                        <Form
                                            onSubmit={(values, toStep) => {
                                                handleSubmit({ values }, toStep);
                                            }}
                                            onChange={() => updateEventDataModified()}
                                            defaultValues={defaultFormValues}
                                        >
                                            {(formApi) => {
                                                const { submitForm, values, errors, asyncErrors } = formApi;
                                                formApiRef.current = formApi;
                                                return (
                                                    <form onSubmit={submitForm} data-testid="event-create.wizard.form">
                                                        <Step
                                                            values={values}
                                                            errors={errors}
                                                            asyncErrors={asyncErrors}
                                                            currentStep={step}
                                                            onSubmit={submitForm}
                                                            showStepHeader={isNotTeamTennisOrDualMatch(values)}
                                                            stepTitles={getStepTitles(step, clubDetails)}
                                                            totalSteps={maxSteps}
                                                            showPaymentSetup={showPaymentSetup}
                                                            formApi={formApi}
                                                            submitting={submitting}
                                                            editing={false}
                                                            openModal={openModal}
                                                            eventType={values.eventType}
                                                            tiers={tiers}
                                                            setTiers={setTiers}
                                                        >
                                                            <StepFields
                                                                tiers={tiers}
                                                                remainingTiers={remainingTiers}
                                                                setRemainingTiers={setRemainingTiers}
                                                                setTiers={setTiers}
                                                                formApi={formApi}
                                                                club={club}
                                                                defaultValues={defaultFormValues}
                                                                currentStep={step}
                                                                showTip={_.get(tips, 'verifiedEvent', true)}
                                                                showPaymentSetup={showPaymentSetup}
                                                                stripeUrl={stripeUrl}
                                                                paymentProvider={paymentProvider}
                                                                activePaymentsEnabled={activePaymentsEnabled}
                                                                isDemoEvent={isDemoEvent}
                                                                openModal={openModal}
                                                                closeCreatePage={closeCreatePage}
                                                                applyForVerified={applyForVerified}
                                                                verificationApplied={verificationApplied}
                                                                onBack={handleStepBack}
                                                                organizers={organizers}
                                                                onHSEventTypeChange={onHSEventTypeChange}
                                                                onEventTypeChange={onEventTypeChange}
                                                                onDivisionFeeChange={onDivisionFeeChange}
                                                                onVerifiedChange={onVerifiedChange}
                                                                setOrganizers={setOrganizers}
                                                                PopUpTypes={PopUpTypes}
                                                                editing={false}
                                                                isOwner={isOwner}
                                                                showUpgradeToPerformanceHsPopup={onShowUpgradeToPerformanceHsPopup}
                                                                isNewEvent={true}
                                                                sportTypeId={sportTypeId}
                                                                isEventCreateForm={true}
                                                            />
                                                        </Step>
                                                    </form>
                                                );
                                            }}
                                        </Form>
                                    )}
                                </>
                            )}
                            {!clubIdInUrl && (
                                <>
                                    {clubsList?.length === 0 && (
                                        <Redirect to="/" />
                                    )}
                                    {clubsList?.length === 1 && (
                                        <Redirect to={`/events/create?clubId=${clubsList[0].id}`} />
                                    )}
                                    {clubsList?.length > 1 && (
                                        <div className={styles.section}>
                                            <div className={`container bg-transparent pl0 pr0 pb0`}>
                                                <h2 data-testid="event-create.club-select.title">Select organization</h2>
                                                <h2 className="bb pb32" data-testid="event-create.club-select.subtitle">to create a new event</h2>
                                            </div>
                                            <ClubSelectForm
                                                handleSubmit={handleClubSelectSubmit}
                                                clubsList={clubsList}
                                                cancel={handleClubSelectCancel}
                                            />
                                        </div>
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                </div>
                <PopupV3
                    title="Error"
                    message={error}
                    type={PopupTypes.ERROR}
                    isOpen={!!error}
                    onConfirmClick={() => {
                        setError(null);
                        setErrorPopUp(true);
                    }}
                />
                <RecurringSubmissionPopups
                    showSaveDraftPopup={showRecurringSaveDraftPopup}
                    showPublishPopup={showRecurringPublishPopup}
                    recurringPublishSelection={recurringPublishSelection}
                    onConfirmSaveDraft={confirmRecurringSaveDraft}
                    onCancelSaveDraft={() => setShowRecurringSaveDraftPopup(false)}
                    onConfirmPublish={confirmRecurringPublish}
                    onCancelPublish={() => setShowRecurringPublishPopup(false)}
                    onToggleSelectAll={toggleSelectAllRecurringPublishSelection}
                    onToggleEvent={updateRecurringPublishSelection}
                    timeZone={values?.eventSchedule?.timeZone || 77} // 'America/Los_Angeles'
                    isPrimaryPublished={!!publish}
                    onTogglePrimary={(checked) => setPublish(checked)}
                    primaryEvent={formApiRef.current?.values || values}
                />
                {showTournamentClubEventPopUp && (
                    <WelcomePopUp
                        dangerouslySetInnerHTML={true}
                        welcomeTitles={{
                            title: 'Let’s set up your first event!',
                            subTitle: 'Run verified and non-verified events',
                            description: 'Once you’ve set up your event, you can publish and promote your event to players. <a href="https://universaltennis.freshdesk.com/support/solutions/articles/9000166563-complete-guide-to-utr-events" target="_blank">Click here to view the complete UTR Sports Events Guide</a>',
                        }}
                        onCloseClick={() => {
                            closeTournamentClubEventPopUp();
                        }}
                        onCtaClick={() => {
                            closeTournamentClubEventPopUp();
                        }}
                    />
                )}

                {events.isEventCreated && (
                    <Redirect to={{
                        pathname: `/events/${events.createdEventId}`,
                    }}
                    />
                )}
                {showIncompletePopup && (
                    <IncompleteApplicationPopup
                        onSaveClick={() => handleSubmit(formApiRef.current.values)}
                        onCloseClick={closePopups}
                        submitting={submitting}
                    />
                )}
                {showUpgradeToPerformanceHsPopup && (
                    <UpgradeToPerformanceHsPopUp
                        onCloseClick={handlePerformanceHsPopupCloseClick}
                        handleUpgradeClick={handlePerformanceHsPopupUpgradeClick}
                        clubOptionsToUpgrade={clubToUpgrade}
                    />
                )}
                {showProClubPopup && (
                    <UpgradeToProClubPopUp
                        data-testid="modal.event-create.upgrade-pro-club"
                        skipIntro={true}
                        onCloseClick={() => setShowProClubPopup(false)}
                        onSuccess={handleProClubSuccess}
                        clubId={clubId}
                        clubTierType={clubDetails.tierType}
                        clubName={clubDetails.name}
                    />
                )}
                <NavigationPrompt
                    // beforeConfirm={cleanup}
                    renderIfNotActive={false}
                    when={(crntLocation, nextLocation) => !overrideClosePageWarning && eventDataModified && (!nextLocation?.pathname?.startsWith(crntLocation.pathname))}
                >
                    {({ isActive, onCancel, onConfirm }) => {
                        if (isActive) {
                            return (
                                <Modal visible={true} onClickBackdrop={onCancel}>
                                    <div className="modal-header">
                                        <div className="text-medium" data-testid="modal.event-create.nav-prompt.title">Warning!</div>
                                        <div
                                            className="close-icon"
                                            onClick={onCancel}
                                        >
                                            <i className="utr utr-close" />
                                        </div>
                                    </div>

                                    <div className={`modal-body`} data-testid="event-create.nav-prompt.modal-body">
                                        <p className="mb24 text-center" data-testid="event-create.nav-prompt.unsaved-changes-msg">
                                            You have unsaved changes. If you leave before saving, your changes will be lost.
                                        </p>
                                        <p className="mb24 text-center" data-testid="event-create.nav-prompt.confirm-leave-msg">
                                            Are you sure you want to leave the page?
                                        </p>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <button
                                                    type="button"
                                                    className={`btn btn-xl btn-block btn-primary`}
                                                    onClick={onCancel}
                                                    data-testid="event-create.nav-prompt.stay-btn"
                                                >
                                                    No
                                                </button>
                                            </div>
                                            <div className="col-md-6">
                                                <button
                                                    type="button"
                                                    className={`btn btn-xl btn-block btn-default`}
                                                    onClick={onConfirm}
                                                    data-testid="event-create.nav-prompt.leave-btn"
                                                >
                                                    Yes
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                </Modal>
                            );
                        }
                        return null;
                    }}
                </NavigationPrompt>
            </div>
        </div>
    );
};

EventCreateForm.propTypes = {
    clubIdInUrl: PropTypes.bool,
    isDemoEvent: PropTypes.bool,
    location: routerLocationShape.isRequired,
    history: routerHistoryShape.isRequired,
    templateId: PropTypes.string,
    defaultValues: PropTypes.shape({
        eventType: PropTypes.number,
        sportTypeId: PropTypes.number,
        name: PropTypes.string,
        email: PropTypes.string,
        phone: PropTypes.string,
        eventDivisions: PropTypes.arrayOf(PropTypes.shape({
            id: PropTypes.number,
            name: PropTypes.string,
            genderId: PropTypes.number,
            divisionFormatTypeId: PropTypes.number,
        })),
        eventLocations: PropTypes.arrayOf(PropTypes.shape({
            id: PropTypes.number,
            name: PropTypes.string,
            address: PropTypes.string,
        })),
        eventSchedule: PropTypes.shape({
            eventStartUtc: PropTypes.string,
            timeZone: timeZoneShape,
            registrationEndString: PropTypes.string,
        }),
        entryFee: PropTypes.number,
        hasEntryFee: PropTypes.bool,
        hasPrizeMoney: PropTypes.bool,
        prizeMoney: PropTypes.number,
        clubId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        currency: PropTypes.shape({
            symbol: PropTypes.string,
            code: PropTypes.string,
        }),
    }),
    club: PropTypes.shape({
        clubDetails: clubShape,
    }),
};

EventCreateForm.defaultProps = {
    clubIdInUrl: false,
    isDemoEvent: false,
    templateId: '',
    defaultValues: null,
    club: null,
};

export default withRouter(EventCreateForm);
